import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import { ErrorHandler } from '@playbookux/playbook-web-core';
import {
  Container,
  DetailsContainer,
  Loader,
  Text,
  VideoContainer,
} from './styles';

import withLayout from '../../../core/components/with-layout';
import HangTight from '../../../core/components/hang-tight';
import { GET_TEST_SESSION_NOTE } from './graphql';
import VideoPlayer, { withMedia } from '../../../core/components/video-player';
import ControlBarSpacer from '../../../core/components/video-player/control-bar-spacer';

const ERROR_MESSAGE = "We're not able to process this clip. Please contact support.";
const HANG_TIGHT_MESSAGE = "Hang tight! We're generating your clip";
const POLL_INTERVAL = 3000;

const Clip = (props) => {
  const {
    match: {
      params: { clipId },
    },
  } = props;

  const {
    loading,
    error,
    data: { testSessionNote } = {},
    stopPolling,
  } = useQuery(GET_TEST_SESSION_NOTE, {
    variables: { id: clipId },
    pollInterval: POLL_INTERVAL,
  });

  const showVideoPlayer = testSessionNote && testSessionNote.status === 'processed';
  const processingError = testSessionNote && testSessionNote.status === 'transcribe_error';

  useEffect(() => {
    if (showVideoPlayer || processingError) {
      stopPolling();
    }
  }, [showVideoPlayer, processingError, stopPolling]);

  if (loading) {
    return (
      <Container>
        <Loader data-loader="clip-loader" />
      </Container>
    );
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        defaultMessage="Error while retrieving clip."
      />
    );
  }

  const showBlackComponent = !showVideoPlayer || processingError;

  return (
    <Container>
      <VideoContainer>
        {showBlackComponent && (
          <HangTight
            processingError={processingError}
            errorMessage={ERROR_MESSAGE}
            hangTightMessage={HANG_TIGHT_MESSAGE}
          />
        )}

        {showVideoPlayer && (
          <VideoPlayer
            src={testSessionNote.videoUrl}
          >
            <ControlBarSpacer
              beforeElement="downloadButton"
            />
          </VideoPlayer>
        )}
      </VideoContainer>

      <DetailsContainer>
        <Text>
          {`Project: ${testSessionNote.testSession.tester.project.name}`}
        </Text>
        <Text>
          {`Participant: ${testSessionNote.testSession.tester.user.profile.firstName}`}
        </Text>
        <Text>
          {`Note: ${testSessionNote.note}`}
        </Text>
      </DetailsContainer>
    </Container>
  );
};

Clip.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clipId: PropTypes.string,
    }),
  }).isRequired,
};

export default withLayout()(withMedia(Clip));
